import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6dff3966&scoped=true"
import script from "./Header.ts?vue&type=script&lang=ts&external"
export * from "./Header.ts?vue&type=script&lang=ts&external"
import style0 from "./Header.vue?vue&type=style&index=0&id=6dff3966&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff3966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dff3966')) {
      api.createRecord('6dff3966', component.options)
    } else {
      api.reload('6dff3966', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=6dff3966&scoped=true", function () {
      api.rerender('6dff3966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/components/details/Header/Header.vue"
export default component.exports